export const useImageHeight = (width) => {
    // keep 16/9 ratio
    const height = width * (9 / 16);
    return height;
};
